import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { App } from '@/types/applications'

interface applicationsInitialState {
  applications: App[]
}

const initialState: applicationsInitialState = {
  applications: []
}

const setAvailableTCSApplications = (
  state: applicationsInitialState = initialState,
  action: PayloadAction<App[]>
) => {
  return {
    ...state,
    applications: action.payload
  }
}

const applicationsSlice = createSlice({
  name: 'applications',
  initialState,
  reducers: {
    setAvailableTCSApplications
  }
})

export const applicationsReducer = applicationsSlice.reducer
export const applicationsActions = applicationsSlice.actions
